<div class="bazis-interval-control"
    *transloco="let t"
>
    <div>
        <p class="bh-text-uppercase bh-font-medium">
            {{ t('title.timeStart') }}
        </p>
        <bazis-timepicker
            [value]="from"
            (valueChange)="setValue($event, 0)"
        ></bazis-timepicker>
    </div>
    <div>
        <p class="bh-text-uppercase bh-font-medium">
            {{ t('title.timeEnd') }}
        </p>
        <bazis-timepicker
            [value]="to"
            (valueChange)="setValue($event, 1)"
        ></bazis-timepicker>
    </div>
</div>
